import { fetchRelevantSolutions } from '@gn-audio/core/api/compatibility-guide/fetch-relevant-solutions';
import { fetchGroupAccessories } from '@gn-audio/core/api/product-catalogue/fetch-group-accessories';
import { fetchSearchGroups } from '@gn-audio/core/api/product-catalogue/fetch-search-groups';
import { excludeEHSFilterQuery } from '../utils/exclude-ehs-filter-query';
var top = 2;
var SolutionOtherProductsComponentController = (function () {
    function SolutionOtherProductsComponentController($q, $location, queryBuilder) {
        this.$q = $q;
        this.$location = $location;
        this.queryBuilder = queryBuilder;
        this.relevantProducts = [];
        this.accessories = [];
    }
    SolutionOtherProductsComponentController.prototype.$onInit = function () {
        var _this = this;
        this.loading = true;
        var searchParams = {
            filter: '',
            top: top,
        };
        var groupAccessoriesPromise = this.$q
            .when(fetchGroupAccessories(this.groupId));
        var search = this.$location.search();
        var filters = (search.filters || '').split(';');
        var includeDiscontinued = this.queryBuilder.getIncludeDiscontinuedType(filters);
        var relevantProductsPromise = this.$q.when(fetchRelevantSolutions(this.thirdPartyDevices.map(function (t) { return t.searchKey; }), this.groupCode, includeDiscontinued));
        this.$q
            .all([groupAccessoriesPromise, relevantProductsPromise])
            .then(function (result) {
            var groupIds = result[0].map(function (accessory) { return accessory.groupId; });
            searchParams.filter = excludeEHSFilterQuery(groupIds);
            _this.$q.when(fetchSearchGroups(searchParams, "available"))
                .then(function (searchResult) {
                _this.accessories = searchResult.items;
                _this.accessories.forEach(function (x) {
                    x.drItem = [{ groupId: x.groupId, name: x.title, sku: x.sku }];
                });
            });
            _this.relevantProducts = result[1];
            if (_this.relevantProducts.length === 1) {
                _this.relevantProducts.push(null);
            }
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    SolutionOtherProductsComponentController.prototype.getRelevantProductSolutionUrl = function (relevantProduct) {
        if (relevantProduct === null) {
            return 'javascript:;';
        }
        var productsUrlParam = this.$location.search().products;
        return this.$location
            .url()
            .substring(1)
            .replace("products=" + productsUrlParam, "products=" + relevantProduct.searchKey)
            .replace(/&cart=([0-9;,]*)/gi, '');
    };
    SolutionOtherProductsComponentController.$inject = ['$q', '$location', 'queryBuilder'];
    return SolutionOtherProductsComponentController;
}());
export var SolutionOtherProductsComponent = {
    bindings: {
        groupCode: '<',
        groupId: '<',
        segmentType: '=?',
        thirdPartyDevices: '<',
    },
    controller: SolutionOtherProductsComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutionotherproducts',
};
